/**
 * @file 欢迅邀请好友（huanxunnavInvite）图片资源集中导出
 * @description 图片统一走 CDN，路径前缀 invite/huanxun/，由 getH5ImgUrl 拼接完整地址。
 */
import AvalonGTConfig from '@/utils/Config';
/** CDN 路径前缀（与 getH5ImgUrl 拼接） */
var CDN_PREFIX = 'invite/huanxun/';
function img(name) {
    return AvalonGTConfig.Global.getH5ImgUrl(CDN_PREFIX + name);
}
var inviteImgs = {
    /** 顶部英雄区背景（标题 + 限时专享卡框 + 装饰） */
    heroBg: img('hero-bg.png'),
    /** 邀请码白卡底图（无补填） */
    cardBg: img('card-bg.png'),
    /** 邀请码白卡底图（含邀请补填，更高） */
    cardBgTall: img('card-bg-tall.png'),
    /** 活动时间条 */
    timeBand: img('time-band.png'),
    /** 时间条两侧心形 */
    iconHeart: img('icon-heart.png'),
    /** 邀请好友按钮底图 */
    btnInvite: img('btn-invite.png'),
    /** 底部列表面板底图 */
    panelBg: img('panel-bg.png'),
    /** 搜索图标 */
    iconSearch: img('icon-search.png'),
    /** 我的奖励旁礼物图标 */
    iconGift: img('icon-gift.png'),
    iconDate: img('date-icon.png'),
    iconDown: img('icon-down.png'),
    /** 邀请记录：实名认证徽章 */
    badgeRealVerify: img('realVerify.png'),
    /** 邀请记录：真人认证徽章 */
    badgeAvatarVerify: img('avatarVerify.png'),
};
export default inviteImgs;
